import styled from 'styled-components';

export const VideoContainer = styled.div(
  props => `
    position: relative; width: 100%;
    `,
);

export const Video = styled.video(
  props => `
display: block; 
width: 100% !important;
height: auto !important;
max-height:384px;
padding: 1rem;
border-radius: 2rem;`,
);

export const VideoButtonsContainer = styled.div(
  props => `position: absolute; bottom: 0; z-index: 1; width: 100%; text-align: center;`,
);

export const VideoButtons = styled.button(props => `margin-left: 10px;`);
